<template>
  <el-dialog
    :visible.sync="show"
    custom-class="success"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="dialog-box">
      <img class="closebtn" src="@/assets/serve/designer/close.png" @click="closeDialog">
      <div class="title">温馨提示</div>
      <div class="info">
        您已{{infoName}}成功，可到个人中心进行查看！
      </div>
      <div class="goMine" @click="goto(`${$Path}/#/mine?classIndex=${classIndex}`)">立即查看</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SignUpSuccess',
  components:{ 
  },
  props: {
    show: {},
    msg:{},
    showbtn: false,
    infoName: {
      type: String,
      default: '报名'
    },
    classIndex: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
        
    }
  },
  computed:{ },
  watch:{ },
  created() {
      
  },
  mounted() {
      
  },
  methods: {
    closeDialog() {
      this.$emit('close', false)
    },
    goto(url) {
      location.href = url
    }
  }
}
</script>
<style lang='less' scoped>
/deep/ .el-dialog.success {
  width: 600px;
  position: absolute;
  top: 34px;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding: 55px 60px;
  border-radius: 30px;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    .dialog-box {
      position: relative;
      .title {
        font-size: 36px;
        font-family: FZLanTingHeiS-DB-GB;
        font-weight: 400;
        color: #4E8B46;
        line-height: 60px;
        margin-bottom: 45px;
        text-align: center;
      }
      .info {
        font-size: 26px;
        font-family: FZLanTingHeiS-R-GB;
        font-weight: 400;
        color: #595858;
        line-height: 70px;
        text-align: center;
      }
      .closebtn {
        width: 70px;
        height: 70px;
        position: absolute;
        top: -75px;
        right: -220px;
        cursor: pointer;
      }
      .goMine {
        width: 280px;
        height: 50px;
        line-height: 50px;
        background: #4E8B46;
        border-radius: 50px;
        margin: 40px auto 0;
        font-size: 24px;
        font-family: FZLanTingHeiS-DB-GB;
        font-weight: 400;
        color: #FFFFFF;
        -webkit-user-select: none;
        cursor: pointer;
      }
    }
  }
}
</style>